import { CdkDragDrop, CdkDragEnter, CdkDragExit, CdkDragMove, CdkDragStart, CdkDragEnd } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { ListInterface } from 'src/app/Inteface/list-interface';
import { ActionModel } from 'src/app/Models/action-model';
import { StepModel } from 'src/app/Models/step-model';
import { WebObjectModel } from 'src/app/Models/web-object-model';
import { DragDropService } from 'src/app/Services/drag-drop.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { PageServiceService } from 'src/app/Services/page-service.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StepServiceService } from 'src/app/Services/step-service.service';
import { ValidationService } from 'src/app/Services/validation.service';
import { CTVModel } from '../../Models/ctv-model';
import { ActionServiceService } from '../../Services/action-service.service';
import { WebobjectServiceService } from '../../Services/webobject-service.service';
import { AddElementComponent } from '../add-element/add-element.component';
import { AddWebObjectComponent } from '../add-web-object/add-web-object.component';
import { ConfirmDialogModel, DialogComponent } from '../dialog/dialog.component';
import { TemplateConfigDialogComponent } from '../template-config-dialog/template-config-dialog.component';
import { ChangeDetectorRef } from '@angular/core';
import { AddApiObjectComponent } from '../add-api-object/add-api-object.component';
import { ApiObjectService } from 'src/app/Services/api-object.service';
import { ApiObjectModel } from 'src/app/Models/api-object-model';
import { CommandStepCopyService } from 'src/app/Services/command-step-copy.service';
import { RestService } from 'src/app/Services/rest.service';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-canvas2',
  templateUrl: './canvas2.component.html',
  styleUrls: ['./canvas2.component.scss']
})
export class Canvas2Component implements OnInit {
  brand = getBrand();
  private options = new Set<string>();
  public showValue: Boolean = false;
  public showValue2: Boolean = false;
  public currentWebPage: string = "";
  public webobjects: any;
  public webpages: any;
  public duplicateIn: any;
  editingStep: boolean = false;
  @Input("showSaveButton") showSaveButton: boolean = true;
  @Output("hideCanvas") hideCanvas = new EventEmitter();
  @Output("onWebPageSave") onWebPageSave = new EventEmitter();
  @Output("onTargetObjectSave") onTargetObjectSave = new EventEmitter();

  undoHistory: any[] = [];
  ctrlKeyPressed = false;
  value: any;
  errorCounter = 0;
  isModified: boolean = false;
  @Input() model: StepModel;
  @Input() ctvList: CTVModel[];
  @Input("ObjectList") ObjectList: ListInterface;
  @Input("ObjectList2") ObjectList2: ListInterface;
  @Input("ActionList") ActionList: ListInterface;
  @Output() canvas = new EventEmitter();
  @Output() canvasSaveAs = new EventEmitter();
  @Output("onDelete") deleteevent = new EventEmitter();
  @Output("modifyStep") modifyEvent = new EventEmitter();
  public isEditingStep: boolean = false;
  webPageNames: any;
  public isPageName: boolean = false;
  pasteAtTop: boolean = false;

  errorMessages: string = "";
  threeList: CTVModel[];

  dragItemIndex: number;
  enteredIndex: number;

  // Context menu properties
  contextMenuVisible: boolean = false;
  contextMenuX: number = 0;
  contextMenuY: number = 0;
  rightClickedIndex: number = -1;
  // Add this property to your Canvas2Component class
  selectAllChecked: boolean = false;
  public showEnglishDescription: boolean = false;
expandedSnippetCtv: any | null = null;

  constructor(
    private webobjectService: WebobjectServiceService,
    private actionService: ActionServiceService,
    private dnd: DragDropService,
    public dialog: MatDialog,
    private router: Router,
    private notifys: NotifyService,
    private webobjectServiceService: WebobjectServiceService,
    private apiObjectService: ApiObjectService,
    private webpageService: PageServiceService,
    private stepService: StepServiceService,
    private validateService: ValidationService,
    private _sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private commandStepCopyService: CommandStepCopyService,
    private restService: RestService

  ) { }

  ngOnInit() {
    if (this.ctvList) {
      for (let i = 0; i < this.ctvList.length; i++) {
        this.addToParamList(this.ctvList[i].value, i)
        // secure mode is controlled by model's value1SecureMode; do not override here
      }
    }
    this.threeList = this.ctvList;

     // Initialize selected property for all items
    if (this.ctvList) {
      for (let i = 0; i < this.ctvList.length; i++) {
        this.addToParamList(this.ctvList[i].value, i);
        // Initialize selected property
        (this.ctvList[i] as any).selected = false;
      }
    }
    this.threeList = this.ctvList;
    
  }

  // Listen for clicks outside context menu to close it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.contextMenuVisible) {
      this.closeContextMenu();
    }
  }

  // Prevent default context menu
  @HostListener('document:contextmenu', ['$event'])
  onDocumentRightClick(event: MouseEvent) {
    // Only prevent default if context menu is showing
    if (this.contextMenuVisible) {
      event.preventDefault();
    }
  }

  /**
 * Handle right-click on canvas background (empty area)
 */
onCanvasRightClick(event: MouseEvent): void {
  // Check if the click was directly on the canvas-list or list element (not on a step)
  const target = event.target as HTMLElement;
  const isCanvasOrList = target.classList.contains('canvas-list') || 
                         target.classList.contains('list');
  
  if (isCanvasOrList) {
    event.preventDefault();
    event.stopPropagation();
    
    // Determine paste position based on click location
    const canvasElement = target.classList.contains('canvas-list') 
      ? target 
      : target.closest('.canvas-list') as HTMLElement;
    
    if (canvasElement) {
      const clickY = event.clientY;
      
      // Get the position of the first step if it exists
      const firstStep = canvasElement.querySelector('.box1');
      
      if (firstStep && this.ctvList.length > 0) {
        const firstStepRect = firstStep.getBoundingClientRect();
        
        // If clicked above the first step, paste at index 0 (top)
        if (clickY < firstStepRect.top) {
          this.rightClickedIndex = 0;
          this.pasteAtTop = true;
        } else {
          // Otherwise paste at the end (bottom)
          this.rightClickedIndex = -1;
          this.pasteAtTop = false;
        }
      } else {
        // No steps exist, paste at index 0
        this.rightClickedIndex = 0;
        this.pasteAtTop = true;
      }
    }
    
    // Show context menu at cursor position
    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;
    this.contextMenuVisible = true;
  }
}


  /**
   * Handle right-click on command step
   */
  onRightClick(event: MouseEvent, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    
    this.rightClickedIndex = index;
    this.pasteAtTop = false; // Reset flag when clicking on a step

    // Show context menu at cursor position
    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;
    this.contextMenuVisible = true;
  }


  dialogValueInput: string = '';
  private dialogIndex: number = -1;
  @ViewChild('valueEditDialog', { static: false }) valueEditDialog: TemplateRef<any>;
  private valueDialogRef: MatDialogRef<any>;
  openValueDialog(index: number) {
    this.dialogIndex = index;
    // Do not show existing value in the dialog for security; start blank
    this.dialogValueInput = '';
    this.valueDialogRef = this.dialog.open(this.valueEditDialog);
  }

  private applyDialogSelection(secure: boolean) {
    if (this.dialogIndex < 0) return;
    const i = this.dialogIndex;
    const newVal = this.dialogValueInput || '';
    this.paramFilter(newVal, this.ctvList[i].value as any, i);
    this.ctvList[i]['value1SecureMode'] = !!secure;
    this.dialogIndex = -1;
    this.dialogValueInput = '';
    if (this.valueDialogRef) {
      this.valueDialogRef.close();
      this.valueDialogRef = null;
    }
    this.cdr.detectChanges();
  }

  applyDialogValue(secure: boolean) {
    // Fallback method if we ever use the inline template in future
    this.applyDialogSelection(secure);
  }

  cancelDialog() {
    if (this.valueDialogRef) {
      this.valueDialogRef.close();
      this.valueDialogRef = null;
    }
    this.dialogIndex = -1;
    this.dialogValueInput = '';
  }

  isValue1Secure(ctv: CTVModel): boolean {
    const flag: any = (ctv as any).value1SecureMode;
    // Default to NOT secure when undefined/null so plain value shows by default
    if (flag === undefined || flag === null) return false;
    // Treat true, 'true', 1, '1' as secure
    return flag === true || flag === 'true' || flag === 1 || flag === '1';
  }

  isValue2Secure(ctv: CTVModel): boolean {
    const flag: any = (ctv as any).value2SecureMode;
    // Default to NOT secure when undefined/null so plain value shows by default
    if (flag === undefined || flag === null) return false;
    // Treat true, 'true', 1, '1' as secure
    return flag === true || flag === 'true' || flag === 1 || flag === '1';
  }

  @HostListener('document:keydown.control')
  onControlKeyDown() {
    this.ctrlKeyPressed = true;
  }
  @HostListener('document:keyup.control')
  onControlKeyUp() {
    this.ctrlKeyPressed = false;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === 'z') {
      this.undo();
      event.preventDefault(); // Prevent the browser's default behavior for Ctrl+Z
    }
  }
  drop(event: CdkDragDrop<CTVModel[]>) {
    let newCtvList: CTVModel[];
    let temp2;

    var index1 = event.currentIndex - 1
    if (event.currentIndex == 0 && event.previousContainer.id == "Objects")
      return;
    if (event.currentIndex != 0 && (event.container.data[index1].command.accepts[0] == 'value') && event.previousContainer.id == "Objects")
      return;
    if (event.currentIndex != 0) {
      temp2 = event.container.data[event.currentIndex - 1]._id;
    }
    let temp1;
    if (event.previousContainer.id == event.container.id) {
    }
    else {
      temp1 = {
        model: JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex])),
        _type: JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex]))._type
      }
      event.previousContainer.data[event.previousIndex] = temp1;
    }
    if (event.previousContainer.id == "Actions") {
      let data = {
        event: event,
        type: 'addDrag'
      };
      this.undoHistory.push({ ...data });
      let cmd = new ActionModel();
      let cmd1 = new ActionModel();
      event.previousContainer.data[event.previousIndex] = event.previousContainer.data[event.previousIndex]['model']
      cmd.name = JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex].name));
      cmd._id = JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex]._id));
      cmd.accepts = JSON.parse(JSON.stringify((event.previousContainer.data[event.previousIndex] as any).accepts));
      event.previousContainer.data[event.previousIndex] = { command: cmd, target: null, target2: null, _id: null, commandSteps_id: null, name: null, value: null, value2: null, seq_no: 0, _type: 'CTV', deleted: 0, errors: [], warnings: [], type: event.previousContainer.data[event.previousIndex].type?JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex].type)):null, value1SecureMode: false, value2SecureMode: false, active: true } as any;
      if (cmd.name === 'else if element present' || cmd.name === 'else if equals ignore case' || cmd.name === 'else if equals to' || cmd.name === 'if element present' || cmd.name === 'if equals ignore case' || cmd.name === 'if equals to' || cmd.name === 'else' || cmd.name === 'loop count' || cmd.name === 'loop equals' || cmd.name === 'loop not equals' || cmd.name === 'loop less than' || cmd.name === 'if less than' || cmd.name === 'if greater than'
        || cmd.name === 'if not equals ignore case' || cmd.name === 'else if not equals to' || cmd.name === 'else if not equals ignore case' || cmd.name === 'else if greater than' || cmd.name === 'else if less than' || cmd.name === 'if greater than or equals to' || cmd.name === 'if less than or equals to' || cmd.name === 'else if greater than or equals to' || cmd.name === 'else if less than or equals to'
      ) 
      {  cmd1.name = 'close statement';
        cmd1._id = '6465ede58fedd0214b2605c7';
        cmd1.accepts = [];
        let close = { command: cmd1, target: null, target2: null, _id: null, commandSteps_id: null, name: null, value: null, value2: null, seq_no: 0, _type: 'CTV', deleted: 0, errors: [], warnings: [], type: null, value1SecureMode: false, value2SecureMode: false, active: true } as any;
        event.container.data.splice(event.currentIndex, 0, close);
      }
      event.container.data = event.container.data == undefined ? [] : event.container.data;
      this.dnd.drop(event);

      event.previousContainer.data[event.previousIndex] = temp1.model
      event.previousContainer.data[event.previousIndex]['showValue'] = true;


    }
    else if (event.previousContainer.id == "Objects") {
      if (event.currentIndex == 0) {
        return
      }
      var tom;
      var index = event.currentIndex - 1
      if (event.previousContainer.data[event.previousIndex]['model'].type == "API") {
        if (event.container.data[index].type !== "API") {
          event.previousContainer.data[event.previousIndex] = temp1.model;
          return;
        }
        tom = new ApiObjectModel();
        tom.name = event.previousContainer.data[event.previousIndex]['model'].name;
        tom._id = event.previousContainer.data[event.previousIndex]['model']._id;
        tom.deleted = event.previousContainer.data[event.previousIndex]['model'].deleted;
        tom.type = event.previousContainer.data[event.previousIndex]['model'].type;
        tom.dbName = event.previousContainer.data[event.previousIndex]['model'].dbName;
        tom.collectionName = event.previousContainer.data[event.previousIndex]['model'].collectionName;
        tom.webpageId = event.previousContainer.data[event.previousIndex]['model'].webpageId;
        tom.request = event.previousContainer.data[event.previousIndex]['model'].request;
        tom.warnings = event.previousContainer.data[event.previousIndex]['model'].warnings;
        tom.selectedWebPageId = event.previousContainer.data[event.previousIndex]['model'].selectedWebPageId;
      } else {
        if (event.container.data[index].type === "API") {
          event.previousContainer.data[event.previousIndex] = temp1.model;
          return;
        }
        tom = new WebObjectModel();
        tom.name = event.previousContainer.data[event.previousIndex]['model'].name;
        tom.type = "WEB";
        tom._id = event.previousContainer.data[event.previousIndex]['model']._id;
        tom.dom_id = event.previousContainer.data[event.previousIndex]['model'].dom_id ? event.previousContainer.data[event.previousIndex]['model'].dom_id : "";
        tom.dom_name = event.previousContainer.data[event.previousIndex]['model'].dome_name ? event.previousContainer.data[event.previousIndex]['model'].dom_name : "";
        tom.tag = event.previousContainer.data[event.previousIndex]['model'].tag ? event.previousContainer.data[event.previousIndex]['model'].tag : "";
        tom.xpath = event.previousContainer.data[event.previousIndex]['model'].xpath ? event.previousContainer.data[event.previousIndex]['model'].xpath : "";
        tom.xpaths = event.previousContainer.data[event.previousIndex]['model'].xpaths ? event.previousContainer.data[event.previousIndex]['model'].xpaths : [];
        tom.css = event.previousContainer.data[event.previousIndex]['model'].css ? event.previousContainer.data[event.previousIndex]['model'].css : "";
        tom.class = event.previousContainer.data[event.previousIndex]['model'].class ? event.previousContainer.data[event.previousIndex]['model'].class : "";
        tom.desc = event.previousContainer.data[event.previousIndex]['model'].desc ? event.previousContainer.data[event.previousIndex]['model'].desc : "";
        tom.link = event.previousContainer.data[event.previousIndex]['model'].link ? event.previousContainer.data[event.previousIndex]['model'].link : "";
        tom.partial_link = event.previousContainer.data[event.previousIndex]['model'].partial_link ? event.previousContainer.data[event.previousIndex]['model'].partial_link : "";
        tom.webobjectType = event.previousContainer.data[event.previousIndex]['model'].webobjectType ? event.previousContainer.data[event.previousIndex]['model'].webobjectType : "";
        tom.horizontal_index = event.previousContainer.data[event.previousIndex]['model'].horizontal_index ? event.previousContainer.data[event.previousIndex]['model'].horizontal_index : "";
        tom.webpageId = event.previousContainer.data[event.previousIndex]['model'].webpageId ? event.previousContainer.data[event.previousIndex]['model'].webpageId['$oid'] : "";
        tom.warnings = event.previousContainer.data[event.previousIndex]['model'].warnings ? event.previousContainer.data[event.previousIndex]['model'].warnings : {};
        tom.selectedWebPageId = event.previousContainer.data[event.previousIndex]['model'].webpageId ? event.previousContainer.data[event.previousIndex]['model'].webPageId : {};
      }
      
      let newCtv = new CTVModel();
      newCtv.type = tom.type;
      newCtv._id = temp2;
      let updateTarget = "target";
      if (
        (event.container.data[index].target == null || event.container.data[index].target == undefined) ||
        (event.container.data[index].target != null && event.container.data[index].command.accepts[1] != 'target')) {
        newCtv.target = tom;

      } else if (event.container.data[index].target2 != null) {
        newCtv.target = tom;
        event.container.data[index].target2 == null;
      }
      else if (event.container.data[index].command.accepts[1] == 'target') {
        newCtv.target2 = tom;
        updateTarget = "target2"
      }
      newCtv.command = this.ctvList[index].command;
      newCtv.value = this.ctvList[index].value;
      newCtv.active = this.ctvList[index].active !== undefined ? this.ctvList[index].active : true;
      if (updateTarget == "target2")
        newCtv.target = this.ctvList[index].target;

      let data = {
        event: event,
        type: 'targetDrop',
        target: this.ctvList[index].target
      }
      this.undoHistory.push({ ...data });
      this.ctvList[index] = newCtv;
      this.validateService.validateCTV(this.ctvList, false);
      event.previousContainer.data[event.previousIndex] = temp1.model;
    }
    else {
      let data = {
        event: event,
        type: 'interchange'
      };
      this.undoHistory.push({ ...data });
      this.dnd.drop(event);
    }
    this.validateService.validateCTV(this.ctvList, false);
  }
  resetTarget2(index: number) {
    this.ctvList[index].target = null;
  }

  drop2(event: CdkDragDrop<CTVModel[]>) {
    let temp2;
    let temp1;
    const inputString = event.container.id;
    const parts = inputString.split("-");
    let enteredIndex = 0;
    let lastPart = 0;
    if (event.distance['y'] > 0) {
      enteredIndex = Math.floor(this.dragItemIndex + (event.distance['y'] / 50));
      // console.log(enteredIndex);
      lastPart = enteredIndex;
    }
    if (event.distance['y'] < 0) {
      enteredIndex = Math.ceil(this.dragItemIndex + (event.distance['y'] / 50));
      // console.log(enteredIndex);
      lastPart = enteredIndex;
    }
    let data = {
      event: event,
      type: 'targetChange',
      currentIndex: lastPart,
      previousIndex: this.dragItemIndex
    };
    this.undoHistory.push({ ...data });


    if (lastPart == 0) {
      return
    }

    var index = lastPart
    var tom;
    if (event.previousContainer.data[this.dragItemIndex]['target'].type == "API") {
      if (event.container.data[index].type !== "API") {
        event.previousContainer.data[event.previousIndex] = temp1.model;
        return;
      }
      tom = new ApiObjectModel();
      tom.name = event.previousContainer.data[this.dragItemIndex]['target'].name;
      tom._id = event.previousContainer.data[this.dragItemIndex]['target']._id;
      tom.deleted = event.previousContainer.data[this.dragItemIndex]['target'].deleted;
      tom.type = event.previousContainer.data[this.dragItemIndex]['target'].type;
      tom.dbName = event.previousContainer.data[this.dragItemIndex]['target'].dbName;
      tom.collectionName = event.previousContainer.data[this.dragItemIndex]['target'].collectionName;
      tom.webpageId = event.previousContainer.data[this.dragItemIndex]['target'].webpageId;
      tom.request = event.previousContainer.data[this.dragItemIndex]['target'].request;
      tom.warnings = event.previousContainer.data[this.dragItemIndex]['target'].warnings;
      tom.selectedWebPageId = event.previousContainer.data[this.dragItemIndex]['target'].selectedWebPageId;
    } else {
      if (event.container.data[index].type === "API") {
        event.previousContainer.data[this.dragItemIndex] = temp1.model;
        return;
      }
      tom = new WebObjectModel();
      tom.name = event.previousContainer.data[this.dragItemIndex]['target'].name;
      tom.type = "WEB";
      tom._id = event.previousContainer.data[this.dragItemIndex]['target']._id;
      tom.dom_id = event.previousContainer.data[this.dragItemIndex]['target'].dom_id ? event.previousContainer.data[this.dragItemIndex]['target'].dom_id : "";
      tom.dom_name = event.previousContainer.data[this.dragItemIndex]['target'].dom_name ? event.previousContainer.data[this.dragItemIndex]['target'].dom_name : "";
      tom.tag = event.previousContainer.data[this.dragItemIndex]['target'].tag ? event.previousContainer.data[this.dragItemIndex]['target'].tag : "";
      tom.xpath = event.previousContainer.data[this.dragItemIndex]['target'].xpath ? event.previousContainer.data[this.dragItemIndex]['target'].xpath : "";
      tom.xpaths = event.previousContainer.data[this.dragItemIndex]['target'].xpaths ? event.previousContainer.data[this.dragItemIndex]['target'].xpaths : [];
      tom.css = event.previousContainer.data[this.dragItemIndex]['target'].css ? event.previousContainer.data[this.dragItemIndex]['target'].css : "";
      tom.class = event.previousContainer.data[this.dragItemIndex]['target'].class ? event.previousContainer.data[this.dragItemIndex]['target'].class : "";
      tom.desc = event.previousContainer.data[this.dragItemIndex]['target'].desc ? event.previousContainer.data[this.dragItemIndex]['target'].desc : "";
      tom.link = event.previousContainer.data[this.dragItemIndex]['target'].link ? event.previousContainer.data[this.dragItemIndex]['target'].link : "";
      tom.partial_link = event.previousContainer.data[this.dragItemIndex]['target'].partial_link ? event.previousContainer.data[this.dragItemIndex]['target'].partial_link : "";
      tom.webobjectType = event.previousContainer.data[this.dragItemIndex]['target'].webobjectType ? event.previousContainer.data[this.dragItemIndex]['target'].webobjectType : "";
      tom.horizontal_index = event.previousContainer.data[this.dragItemIndex]['target'].horizontal_index ? event.previousContainer.data[this.dragItemIndex]['target'].horizontal_index : "";
      tom.webpageId = event.previousContainer.data[this.dragItemIndex]['target'].webpageId ? event.previousContainer.data[this.dragItemIndex]['target'].webpageId['$oid'] : "";
      tom.warnings = event.previousContainer.data[this.dragItemIndex]['target'].warnings ? event.previousContainer.data[this.dragItemIndex]['target'].warnings : {};
      tom.selectedWebPageId = event.previousContainer.data[this.dragItemIndex]['target'].webpageId ? event.previousContainer.data[this.dragItemIndex]['target'].webPageId : {};
    }
    let newCtv = new CTVModel();
    newCtv.type = tom.type;
    newCtv._id = temp2;
    let updateTarget = "target";
    if (
      (event.container.data[index].target == null || event.container.data[index].target == undefined) ||
      (event.container.data[index].target != null && event.container.data[index].command.accepts[1] != 'target')) {
      newCtv.target = tom;

    } else if (event.container.data[index].target2 != null) {
      newCtv.target = tom;
      event.container.data[index].target2 == null;
    }
    else if (event.container.data[index].command.accepts[1] == 'target') {
      newCtv.target2 = tom;
      updateTarget = "target2"
    }
    newCtv.command = this.ctvList[index].command;
    newCtv.value = this.ctvList[index].value;
    newCtv.active = this.ctvList[index].active !== undefined ? this.ctvList[index].active : true;
    if (updateTarget == "target2")
      newCtv.target = this.ctvList[index].target;

    this.ctvList[index] = newCtv;
    // console.log(this.ctvList);
    this.validateService.validateCTV(this.ctvList, false);
    // event.previousContainer.data[this.dragItemIndex] = temp1.target;


  }
  toggleElement(toggleElement) {
    if (toggleElement.hidden == undefined)
      toggleElement.hidden = true
    toggleElement.hidden = !toggleElement.hidden
  }
  entered(event: CdkDragEnter<string[]>) {
    // console.log(event)
    if (event.item.element.nativeElement.id == "Objects" && event.currentIndex == 0) {
      event.container.element.nativeElement.children[event.currentIndex].className = "blockDrop";
    }
    else {
      if (event.container.element.nativeElement.children.length == 1) {
        event.container.element.nativeElement.children[0].className = "allowDrop";
      }
      else {
        event.container.element.nativeElement.children[event.currentIndex].className = "allowDrop";
      }
    }
  }
  exited(event: CdkDragExit<string[]>) {
  }
  moveElement(event: CdkDragMove<string[]>) {
  }
  sortElements(event: CdkDragMove<string[]>) {
  }
  saveCanvas2() {
    this.validateService.validateCTV(this.ctvList, true);
    if (this.errorCounter != 0) {
      return;
    }
    this.populateEnglishDescriptions();
    this.canvas.emit(this.ctvList);
  }
  showInput(event = "", i) {
    if (this.ctvList[i]['showValue'] == undefined)
      this.ctvList[i]['showValue'] = this.showValue;
    this.ctvList[i]['showValue'] = !this.ctvList[i]['showValue'];
    this.addToParamList(this.ctvList[i]['value'], i)
  }
  showInput2(event = "", i) {
    if (this.ctvList[i]['showValue2'] == undefined)
      this.ctvList[i]['showValue2'] = this.showValue2;
    this.ctvList[i]['showValue2'] = !this.ctvList[i]['showValue2'];
    this.addToParamList(this.ctvList[i]['value2'], i)
  }
  getShowInputValue(i) {
    if (this.ctvList[i]['showValue'] == undefined)
      this.ctvList[i]['showValue'] = this.showValue;
    return this.ctvList[i]['showValue'];
  }
  getShowInputValue2(i) {
    if (this.ctvList[i]['showValue2'] == undefined)
      this.ctvList[i]['showValue2'] = this.showValue2;
    return this.ctvList[i]['showValue2'];
  }
  delete(item, i) {
    if (item._id == undefined) {
      this.ctvList.splice(i, 1);
    }
    else {
      this.undoHistory.push({ ...item });
      this.deleteConfirmation(item);
    }
  }

  toggleActive(ctv: CTVModel, index: number) {
    // Store previous state for undo
    const previousState = {
      index: index,
      active: ctv.active,
      type: 'toggleActive'
    };
    this.undoHistory.push(previousState);

    // Toggle active status
    // Default to true if undefined/null, so we check for explicit false
    ctv.active = ctv.active === false ? true : false;

    this.cdr.detectChanges();
  }
  deleteConfirmation(item) {
    const message = `Please save the changes after deleteing! `;
    const dialogData = new ConfirmDialogModel("Delete !!!", message);
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.deleteevent.emit(item);
      }
      else {
        this.notifys.notify('warning', 'Aborted', "Deletion Aborted By User!!!");
      }
    });
  }
  public paramFilter(event, value, i) {
    let data = {
      event: event,
      oldValue: value,
      index: i,
      type: 'value'
    };
    this.undoHistory.push({ ...data });
    // console.log(this.undoHistory)
    this.ctvList[i].value = event;
    this.ctvList[i]['filteredOptions'] = this._filter(event)
  }
  // Inline value-1 editing helpers
  startValueEdit(index: number) {
    if (this.ctvList[index]['showValue'] == undefined)
      this.ctvList[index]['showValue'] = this.showValue;
    // keep a backup to support Esc cancel
    (this.ctvList[index] as any)._value1Backup = this.ctvList[index].value;
    this.ctvList[index]['showValue'] = true;
    // initialize options list when entering edit
    this.initParamList(index);
  }

  finishValueEdit(index: number) {
    const oldValue = (this.ctvList[index] as any)._value1Backup;
    const newValue = this.ctvList[index].value;
    // push via shared method to keep undo history consistent
    this.paramFilter(newValue, oldValue, index);
    delete (this.ctvList[index] as any)._value1Backup;
    this.ctvList[index]['showValue'] = false;
    this.cdr.detectChanges();
  }

  cancelValueEdit(index: number) {
    const backup = (this.ctvList[index] as any)._value1Backup;
    if (backup !== undefined) {
      this.ctvList[index].value = backup;
      delete (this.ctvList[index] as any)._value1Backup;
    }
    this.ctvList[index]['showValue'] = false;
    this.cdr.detectChanges();
  }

  // Commands whose Value 2 is a JSON validation template — these get the
  // richer Configure dialog (JSON + Table views) instead of plain inline
  // text editing. Everything else keeps using startValue2Edit unchanged.
  private readonly templateMatchCommandNames = [
    'validate response template',
    'verify response matches template',
  ];

  isTemplateMatchCommand(ctv: any): boolean {
    const name = ctv && ctv.command && ctv.command.name;
    return this.templateMatchCommandNames.indexOf(name) !== -1;
  }

  onValue2Clicked(ctv: any, index: number): void {
    if (this.isTemplateMatchCommand(ctv)) {
      this.openTemplateConfigDialog(index);
    } else {
      this.startValue2Edit(index);
    }
  }

  openTemplateConfigDialog(index: number): void {
    const ctv = this.ctvList[index];
    const oldValue = ctv.value2;
    const dialogRef = this.dialog.open(TemplateConfigDialogComponent, {
      width: '1040px',
      maxWidth: '95vw',
      height: '700px',
      maxHeight: '85vh',
      autoFocus: false,
      data: { template: oldValue || '' },
    });
    dialogRef.afterClosed().subscribe((result: string) => {
      if (result !== null && result !== undefined) {
        this.paramFilter2(result, oldValue, index);
        this.cdr.detectChanges();
      }
    });
  }

  // Inline value-2 editing helpers
  startValue2Edit(index: number) {
    if (this.ctvList[index]['showValue2'] == undefined)
      this.ctvList[index]['showValue2'] = this.showValue2;
    // keep a backup to support Esc cancel
    (this.ctvList[index] as any)._value2Backup = this.ctvList[index].value2;
    this.ctvList[index]['showValue2'] = true;
    // initialize options list when entering edit
    this.initParamList(index);
  }

  finishValue2Edit(index: number) {
    const oldValue = (this.ctvList[index] as any)._value2Backup;
    const newValue = this.ctvList[index].value2;
    // push via shared method to keep undo history consistent
    this.paramFilter2(newValue, oldValue, index);
    delete (this.ctvList[index] as any)._value2Backup;
    this.ctvList[index]['showValue2'] = false;
    this.cdr.detectChanges();
  }

  cancelValue2Edit(index: number) {
    const backup = (this.ctvList[index] as any)._value2Backup;
    if (backup !== undefined) {
      this.ctvList[index].value2 = backup;
      delete (this.ctvList[index] as any)._value2Backup;
    }
    this.ctvList[index]['showValue2'] = false;
    this.cdr.detectChanges();
  }

  toggleSecure(index: number) {
    const wasSecure = this.isValue1Secure(this.ctvList[index]);
    const current = (this.ctvList[index] as any).value1SecureMode;
    (this.ctvList[index] as any).value1SecureMode = !(current === true || current === 'true' || current === 1 || current === '1');
    // If we are unlocking from a secured state, clear the visible input value
    const nowSecure = this.isValue1Secure(this.ctvList[index]);
    if (wasSecure && !nowSecure) {
      this.ctvList[index].value = '';
    }
    this.cdr.detectChanges();
  }

  toggleSecure2(index: number) {
    const wasSecure = this.isValue2Secure(this.ctvList[index]);
    const current = (this.ctvList[index] as any).value2SecureMode;
    (this.ctvList[index] as any).value2SecureMode = !(current === true || current === 'true' || current === 1 || current === '1');
    // If we are unlocking from a secured state, clear the visible input value
    const nowSecure = this.isValue2Secure(this.ctvList[index]);
    if (wasSecure && !nowSecure) {
      this.ctvList[index].value2 = '';
    }
    this.cdr.detectChanges();
  }
  public paramFilter2(event, value, i) {
    let data = {
      event: event,
      oldValue: value,
      index: i,
      type: 'value2'
    };
    this.undoHistory.push({ ...data });
    // console.log(this.undoHistory)
    this.ctvList[i].value2 = event;
    this.ctvList[i]['filteredOptions'] = this._filter(event)
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return [...this.options].filter(option => option.toLowerCase().includes(filterValue));
  }
  public initParamList(i) {
    this.ctvList[i]['filteredOptions'] = this.options;
  }
  public addToParamList(event, i) {
    if (this.ctvList[i]['value'] && this.ctvList[i]['value'].startsWith('##') && this.ctvList[i]['value'].length > 2)
      this.options.add(event)
  }
  navigateBack() {
    if (!window.location.href.includes('canvas'))
      this.router.navigate(['./library'])
    else
      this.hideCanvas.emit(true);
  }
  addNewElement(index, targetNumber) {
    const originalCopy = JSON.parse(JSON.stringify(this.ctvList[index]));
    delete originalCopy.priority;
    originalCopy.actionDone = 'edited';
    originalCopy.index = index;
    this.undoHistory.push({ ...originalCopy });
    let targetElement = this.ctvList[index].target;
    if(targetNumber == 1) {
      this.currentWebPage = this.ctvList[index].target.webpageId;
      if (!this.ctvList[index].target.webobjectType && this.ctvList[index].type !== 'API')
        this.ctvList[index].target.webobjectType = "xpath";
    } else if (targetNumber == 2) {
      targetElement = this.ctvList[index].target2;
      this.currentWebPage = this.ctvList[index].target2.webpageId;
      if (!this.ctvList[index].target2.webobjectType)
        this.ctvList[index].target2.webobjectType = "xpath";
    }

    if (this.ctvList[index].type === 'API') {
      var apiDialogRef = this.dialog.open(AddApiObjectComponent, { data: { element: JSON.parse(JSON.stringify(targetElement)), webpage: this.currentWebPage, showView: 'selectWebPageOptions', 'stepId': this.model['_id'] } });
      apiDialogRef.afterClosed().subscribe(result => {
        if (result.wpname) {
          result = {
            "name": result.wpname,
            "desc": result.wpdesc,
            "url": result.wpurl,
            "defaultPage": result.wpdefaultPage,
          }
          delete result.wpname;
          delete result.wpdesc;
          delete result.wpurl;
          delete result.webpagename;
          // delete result.priority;
          this.webpageService.addWebPagedb2(result).subscribe(
            data => {
              this.currentWebPage = data['data'];
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('success', 'Success', "New Web Page Added");
              this.onWebPageSave.emit();
              this.webpageService.getdb2Items().subscribe(newList => {
                var dialogRef1 = this.dialog.open(AddWebObjectComponent, { data: { element: JSON.parse(JSON.stringify(targetElement)), webpage: this.currentWebPage, showView: 'displaywebobject', 'stepId': this.model['_id'] } });
                dialogRef1.afterClosed().subscribe(result => {
                  this.updatedb2Webobject(result);
                },
                  error => {
                    this.notifys.notify('error', 'Error', error);
                    this._sharedService.loaderHide.emit(false)
                    this.notifys.notify('error', 'Error', "unable to add webpage")
                  });
              });
            },
            error => {
              this.notifys.notify('error', 'Error', error);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('error', 'Error', "unable to add webpage")
            }
          );
        }
        else {
          // delete result.priority;
          if (this.router.url.toUpperCase().includes("CANVAS"))
            this.updatedb2ApiObject(result);
          else
            this.updateApiObject(result);
        }
      });
    } else {
      var dialogRef = this.dialog.open(AddWebObjectComponent, { data: { element: JSON.parse(JSON.stringify(targetElement)), webpage: this.currentWebPage, showView: 'selectWebPageOptions', 'stepId': this.model['_id'] } });
      dialogRef.afterClosed().subscribe(result => {
        if (result.wpname) {
          result = {
            "name": result.wpname,
            "desc": result.wpdesc,
            "url": result.wpurl,
            "defaultPage": result.wpdefaultPage,
          }
          delete result.wpname;
          delete result.wpdesc;
          delete result.wpurl;
          delete result.webpagename;
          // delete result.priority;
          this.webpageService.addWebPagedb2(result).subscribe(
            data => {
              this.currentWebPage = data['data'];
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('success', 'Success', "New Web Page Added");
              this.onWebPageSave.emit();
              this.webpageService.getdb2Items().subscribe(newList => {
                var dialogRef1 = this.dialog.open(AddWebObjectComponent, { data: { element: JSON.parse(JSON.stringify(targetElement)), webpage: this.currentWebPage, showView: 'displaywebobject', 'stepId': this.model['_id'] } });
                dialogRef1.afterClosed().subscribe(result => {
                  this.updatedb2Webobject(result);
                },
                  error => {
                    this.notifys.notify('error', 'Error', error);
                    this._sharedService.loaderHide.emit(false)
                    this.notifys.notify('error', 'Error', "unable to add webpage")
                  });
              });
            },
            error => {
              this.notifys.notify('error', 'Error', error);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('error', 'Error', "unable to add webpage")
            }
          );
        }
        else {
          // delete result.priority;
          if (this.router.url.toUpperCase().includes("CANVAS"))
            this.updatedb2Webobject(result);
          else
            this.updateWebobject(result);
  
        }
      });
    } 
  }

  updatedb2ApiObject(result) {
    if (result != undefined) {
      delete result.wpname;
      delete result.wpdesc;
      delete result.wpurl;
      delete result.webpagename;
      this.currentWebPage = result.selectedWebPageId ? result.selectedWebPageId : result.webpageId;
      // this.validateService.validateWebObject(result);
      this.apiObjectService.updateObjectDb2(this.currentWebPage, result).subscribe(
        data => {
          this.ctvList.forEach(ctv => {
            if (ctv.target && ctv.target._id === result._id) {
              ctv.target = result;
            }
            if (ctv.target2 && ctv.target2._id === result._id) {
              ctv.target2 = result;
            }
          });
          this.onWebPageSave.emit();
          this.notifys.notify('success', 'Success', 'Web Object Successfully added ');
        },
        error => {
          this.notifys.notify('error', 'Error', error);
        }
      );
    }
  }

  updateApiObject(result) {
    if (result != undefined) {
      delete result.wpname;
      delete result.wpdesc;
      delete result.wpurl;
      delete result.webpagename;
      this.currentWebPage = result.webpageId;
      // this.validateService.validateWebObject(result);
      this.apiObjectService.updateObject(this.currentWebPage, result).subscribe(
        data => {
          this.ctvList.forEach(ctv => {
            if (ctv.target && ctv.target._id === result._id) {
              ctv.target = result;
            }
            if (ctv.target2 && ctv.target2._id === result._id) {
              ctv.target2 = result;
            }
          });
          this.onTargetObjectSave.emit();
          this.notifys.notify('success', 'Success', 'Web Object Successfully added ');
        },
        error => {
          this.notifys.notify('error', 'Error', error);
        }
      );
    }
  }
  
  updatedb2Webobject(result) {
    if (result != undefined) {
      delete result.wpname;
      delete result.wpdesc;
      delete result.wpurl;
      delete result.webpagename;
      this.currentWebPage = result.selectedWebPageId ? result.selectedWebPageId : result.webpageId;
      this.validateService.validateWebObject(result);
      this.webobjectServiceService.updateObjectdb2(this.currentWebPage, result).subscribe(
        data => {
          this.ctvList.forEach(ctv => {
            if (ctv.target && ctv.target._id === result._id) {
              ctv.target = result;
            }
            if (ctv.target2 && ctv.target2._id === result._id) {
              ctv.target2 = result;
            }
          });
          this.onWebPageSave.emit();
          this.notifys.notify('success', 'Success', 'Web Object Successfully added ');
        },
        error => {
          this.notifys.notify('error', 'Error', error);
        }
      );
    }
  }

  updateWebobject(result) {
    if (result != undefined) {
      delete result.wpname;
      delete result.wpdesc;
      delete result.wpurl;
      delete result.webpagename;
      this.currentWebPage = result.webpageId;
      this.validateService.validateWebObject(result);
      this.webobjectServiceService.updateObject(this.currentWebPage, result).subscribe(
        data => {
          this.ctvList.forEach(ctv => {
            if (ctv.target && ctv.target._id === result._id) {
              ctv.target = result;
            }
            if (ctv.target2 && ctv.target2._id === result._id) {
              ctv.target2 = result;
            }
          });
          this.onTargetObjectSave.emit();
          this.notifys.notify('success', 'Success', 'Web Object Successfully added ');
        },
        error => {
          this.notifys.notify('error', 'Error', error);
        }
      );
    }
  }
  modifyStep() {
    this.editingStep = !this.editingStep;
    this.modifyEvent.emit(this.editingStep);
    this.isModified = !this.isModified;
    this.isEditingStep = !this.isEditingStep;
  }
  saveCanvasdb2() {
    this.validateService.validateCTV(this.ctvList, true);
    this.populateEnglishDescriptions();
    this.canvas.emit(this.ctvList);
  }
  saveAsCanvasdb2() {
    const stepmodel = {
      _id: this.model['_id'],
      name: this.model.name,
      commandSteps: this.ctvList,
    }
    this.populateEnglishDescriptions();
    this.canvasSaveAs.emit(stepmodel);
  }
  saveAsModel(formData: any = {}) {
    if (this.validateService.validateCTV(this.ctvList, true)) {
      this.webpageService.getItems().subscribe(response => {
        this.webpages = response['data'].filter(Boolean);
        this.doSomethingWithGlobalVariable(this.webpages, formData.name);
        // console.log('data', this.webpages);

      }, error => {
        console.log('fail');
      });

      this.stepService.getItemsdb1().subscribe(
        db1StepList => {
          let dialogRef = this.dialog.open(AddElementComponent,
            {
              data: {
                event: event,
                title: ("Save Step to Library"),
                name: formData.name,
                list: db1StepList['data'].map((item) => {
                  return item['name']
                }),
                hideList: true,
                pageList: this.webPageNames,
                duplicateMessage: "Step name already exist",
                pageDuplicateMessage: "Page name already exist"
              }
            });
          dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
              var stepmodel = {
                _id: this.model['_id'],
                name: dialogResult.name,
                commandSteps: this.ctvList,
              }
            }
            this.canvasSaveAs.emit(stepmodel);
          });
        });
    }
  }
  doSomethingWithGlobalVariable(webpages: any, name: any) {
    this.webPageNames = webpages.map(item => item['name']);
    this.isPageName = this.webPageNames.includes(name);
    // console.log(this.webPageNames);
  }

  errorMessage(name: any): string {
    if (this.webPageNames.includes(name)) {
      this.errorMessages = "Page";
      return name;
    }
    else {
      console.log(this.webPageNames.includes(name))
      this.errorMessages = "Step";
      return name;
    }
  }

  undo() {
    if (this.undoHistory.length > 0) {
      const prevState = this.undoHistory.pop();

       if (prevState.type === 'paste') {
        // Remove pasted steps
        this.ctvList.splice(prevState.insertIndex, prevState.count);
        this.cdr.detectChanges();
      }
      else if (prevState.type === 'bulkEnable') {
      // Restore previous active states
      prevState.changes.forEach(change => {
        if (this.ctvList[change.index]) {
          this.ctvList[change.index].active = change.previousActive;
        }
      });
      this.cdr.detectChanges();
    }
      else if (prevState.type === 'bulkDisable') {
        // Restore previous active states
        prevState.changes.forEach(change => {
          if (this.ctvList[change.index]) {
            this.ctvList[change.index].active = change.previousActive;
          }
        });
        this.cdr.detectChanges();
      }
      else if (prevState.type === 'bulkDelete') {
        // Restore deleted steps
        prevState.deletedSteps.reverse().forEach(deleted => {
          this.ctvList.splice(deleted.index, 0, deleted.step);
        });
        this.cdr.detectChanges();
      }
      else if (prevState.actionDone) {
        const index = prevState.index;
        delete prevState.index;
        delete prevState.actionDone;
        this.ctvList[index] = prevState;
        prevState.target.changedwebpageId = '';
        prevState.target.webpageId = prevState.target.webpageId.$oid;
        prevState.target.selectedWebPageId = prevState.target.webpageId;
        this.updateWebobject(prevState.target);
      }
      else if (prevState.event && prevState.type == 'interchange') {
        const currentIndex = prevState.event.previousIndex;
        const previousIndex = prevState.event.currentIndex;
        prevState.event.currentIndex = currentIndex;
        prevState.event.previousIndex = previousIndex;
        let element = prevState.event.previousContainer.data[previousIndex];
        this.ctvList.splice(prevState.event.previousIndex, 1);
        // console.log(element)
        this.ctvList.splice(prevState.event.currentIndex, 0, element);
      }
      else if (prevState.event && prevState.type == 'addDrag') {
        this.ctvList.splice(prevState.event.currentIndex, 1);
      }
      else if (prevState.event && prevState.type == 'targetDrop') {
        this.ctvList[prevState.event.currentIndex - 1].target = prevState.target;
      }
      else if (prevState.event && prevState.type == 'value') {
        this.ctvList[prevState.index].value = prevState.oldValue;
        this.cdr.detectChanges();
        // console.log(this.ctvList)
      }
      else if (prevState.event && prevState.type == 'value2') {
        this.ctvList[prevState.index].value2 = prevState.oldValue;
        this.cdr.detectChanges();
        // console.log(this.ctvList)
      }
      else if (prevState.event && prevState.type == 'targetChange') {
        // console.log(prevState);
        this.ctvList[prevState.currentIndex] = prevState.event.previousContainer[prevState.currentIndex].target;
      }
      else if (prevState.type == 'toggleActive') {
        this.ctvList[prevState.index].active = prevState.active;
        this.cdr.detectChanges();
      }
      else if (prevState.type === 'descriptionEdit') {
          const ctv: any = this.ctvList[prevState.index];
          if (ctv) {
            ctv.englishDescription = prevState.oldValue;
            ctv.english_description = prevState.oldValue;
            ctv.manualEnglishDescription = prevState.oldManualFlag;
          }
          this.cdr.detectChanges();
        }
      else {
        for (let i = 0; i < this.ctvList.length; i++) {
          if (this.ctvList[i]._id == prevState._id) {
            this.ctvList[i].deleted = 0;
          }
        }
      }
    }
  }

  dragStarted(event: CdkDragStart, index: number) {
    this.dragItemIndex = index;
    this.dnd.onDragStarted();
    // console.log("index", index);
  }

  dragEnded(event: CdkDragEnd) {
    this.dnd.onDragEnded();
  }

  dragDropped(event: CdkDragDrop<CTVModel[]>) {
    // console.log(event);
  }

  onDragEntered(index: number) {
    this.enteredIndex = index; // Update enteredIndex when item enters a new position
  }

  /**
   * Check if any steps are selected
   */
  hasSelectedSteps(): boolean {
    return this.ctvList.some(ctv => (ctv as any).selected === true);
  }

  /**
   * Close context menu
   */
  closeContextMenu(): void {
    this.contextMenuVisible = false;
    this.rightClickedIndex = -1;
  }

  /**
   * Get selected steps
   */
  getSelectedSteps(): CTVModel[] {
    return this.ctvList.filter(ctv => (ctv as any).selected === true);
  }

/**
 * Toggle select/deselect all command steps
 */
toggleSelectAll(): void {
  // Apply selection state to all non-deleted steps
  this.ctvList.forEach(ctv => {
    if (ctv.deleted === 0) {
      (ctv as any).selected = this.selectAllChecked;
    }
  });
  
  this.cdr.detectChanges();
}

/**
 * Update select all checkbox state based on individual selections
 * Call this in onSelectionChange() method
 */
updateSelectAllState(): void {
  const visibleSteps = this.ctvList.filter(ctv => ctv.deleted === 0);
  const selectedSteps = visibleSteps.filter(ctv => (ctv as any).selected === true);
  
  // If all visible steps are selected, check the select-all box
  // If none are selected, uncheck it
  // If some are selected, you could add an indeterminate state
  if (selectedSteps.length === 0) {
    this.selectAllChecked = false;
  } else if (selectedSteps.length === visibleSteps.length) {
    this.selectAllChecked = true;
  } else {
    // Optional: Handle partial selection
    // You could use mat-checkbox's indeterminate state here
    this.selectAllChecked = false;
  }
}

/**
 * Check if selection is partial (some but not all selected)
 */
isPartialSelection(): boolean {
  const visibleSteps = this.ctvList.filter(ctv => ctv.deleted === 0);
  const selectedSteps = visibleSteps.filter(ctv => (ctv as any).selected === true);
  
  return selectedSteps.length > 0 && selectedSteps.length < visibleSteps.length;
}

   /**
   * Copy selected steps to clipboard service
   */
  copySelectedSteps(): void {
    if (!this.hasSelectedSteps()) {
      this.closeContextMenu();
      return;
    }

    const selectedSteps = this.getSelectedSteps();
    const projectId = this.getProjectId();
    
    // Store in clipboard service (in-memory only)
    this.commandStepCopyService.copySteps(selectedSteps, projectId);
    
    // Show success notification
    this.notifys.notify('success', 'Copied', `${selectedSteps.length} step(s) copied`);
    
    this.clearAllSelections()
    this.closeContextMenu();
  }


   /**
   * Check if paste is available
   */
  canPaste(): boolean {
    const projectId = this.getProjectId();
    return this.commandStepCopyService.hasCopiedSteps(projectId);
  }

  /**
   * Paste copied steps
   */
  pasteSteps(): void {
    const projectId = this.getProjectId();
    
    if (!this.canPaste()) {
      this.closeContextMenu();
      return;
    }

    const copiedSteps = this.commandStepCopyService.getCopiedSteps(projectId);
    
    if (copiedSteps.length === 0) {
      this.closeContextMenu();
      return;
    }

    // Determine insert position based on pasteAtTop flag
  let insertIndex: number;
  
  if (this.pasteAtTop) {
    // Paste at the top (index 0)
    insertIndex = 0;
  } else if (this.rightClickedIndex === -1) {
    // Paste at the bottom
    insertIndex = this.ctvList.length;
  } else {
    // Paste after the clicked step
    insertIndex = this.rightClickedIndex + 1;
  }

    // Insert copied steps
    const pastedSteps: CTVModel[] = [];
    
    copiedSteps.forEach((step, idx) => {
      const newStep = { ...step };
      
      // Clear selected state
      (newStep as any).selected = false;
      
      // Mark as pasted for animation
      (newStep as any).pasted = true;
      
      // Insert at position
      this.ctvList.splice(insertIndex + idx, 0, newStep);
      pastedSteps.push(newStep);
    });

    // Add to undo history
    const undoData = {
      type: 'paste',
      insertIndex: insertIndex,
      count: copiedSteps.length
    };
    this.undoHistory.push(undoData);

    // Validate after paste
    this.validateService.validateCTV(this.ctvList, false);
    
    // Show success notification
    this.notifys.notify('success', 'Pasted', `${copiedSteps.length} step(s) pasted`);
    
    // Remove paste highlight after animation
    setTimeout(() => {
      pastedSteps.forEach(step => {
        delete (step as any).pasted;
      });
      this.cdr.detectChanges();
    }, 1500);
    
    this.closeContextMenu();
    this.cdr.detectChanges();
  }

    /**
   * Handle selection change
   */
  onSelectionChange(): void {
    // Update the select-all checkbox state
    this.updateSelectAllState();
    // Optional: Add any logic when selection changes
    this.cdr.detectChanges();
  }

   /**
   * Get selected step indices
   */
  getSelectedIndices(): number[] {
    return this.ctvList
      .map((ctv, index) => ((ctv as any).selected ? index : -1))
      .filter(index => index !== -1);
  }

   /**
   * Clear all selections
   */
  clearAllSelections(): void {
    this.ctvList.forEach(ctv => {
      (ctv as any).selected = false;
    });
    this.selectAllChecked = false;
    this.cdr.detectChanges();
  }

  /**
 * Check if there are any active selected steps
 */
hasActiveSelectedSteps(): boolean {
  return this.ctvList.some(ctv => 
    (ctv as any).selected === true && ctv.active !== false
  );
}

/**
 * Check if there are any inactive selected steps
 */
hasInactiveSelectedSteps(): boolean {
  return this.ctvList.some(ctv => 
    (ctv as any).selected === true && ctv.active === false
  );
}

/**
 * Enable selected steps (only affects inactive steps)
 */
enableSelectedSteps(): void {
  if (!this.hasSelectedSteps() || !this.hasInactiveSelectedSteps()) {
    this.closeContextMenu();
    return;
  }

  const selectedIndices = this.getSelectedIndices();
  
  // Store undo data
  const undoData = {
    type: 'bulkEnable',
    changes: selectedIndices.map(index => ({
      index: index,
      previousActive: this.ctvList[index].active
    }))
  };
  this.undoHistory.push(undoData);

  // Enable all selected inactive steps
  let enabledCount = 0;
  selectedIndices.forEach(index => {
    if (this.ctvList[index].active === false) {
      this.ctvList[index].active = true;
      enabledCount++;
    }
  });

  // Clear selections
  this.clearAllSelections();
  
  // Show notification
  this.notifys.notify('success', 'Enabled', `${enabledCount} step(s) enabled`);
  
  this.closeContextMenu();
  this.cdr.detectChanges();
}

/**
 * Disable selected steps (only affects active steps)
 */
disableSelectedSteps(): void {
  if (!this.hasSelectedSteps() || !this.hasActiveSelectedSteps()) {
    this.closeContextMenu();
    return;
  }

  const selectedIndices = this.getSelectedIndices();
  
  // Store undo data
  const undoData = {
    type: 'bulkDisable',
    changes: selectedIndices.map(index => ({
      index: index,
      previousActive: this.ctvList[index].active
    }))
  };
  this.undoHistory.push(undoData);

  // Disable all selected active steps
  let disabledCount = 0;
  selectedIndices.forEach(index => {
    if (this.ctvList[index].active !== false) {
      this.ctvList[index].active = false;
      disabledCount++;
    }
  });

  // Clear selections
  this.clearAllSelections();
  
  // Show notification
  this.notifys.notify('success', 'Disabled', `${disabledCount} step(s) disabled`);
  
  this.closeContextMenu();
  this.cdr.detectChanges();
}

  /**
   * Delete selected steps
   */
  deleteSelectedSteps(): void {
    if (!this.hasSelectedSteps()) {
      this.closeContextMenu();
      return;
    }

    const selectedSteps = this.getSelectedSteps();
    const selectedIndices = this.getSelectedIndices();
    
    // Show confirmation dialog
    const message = `Are you sure you want to delete ${selectedSteps.length} step(s)? Please save the changes after deleting!`;
    const dialogData = new ConfirmDialogModel("Delete Steps", message);
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        // Store undo data
        const undoData = {
          type: 'bulkDelete',
          deletedSteps: selectedIndices.map(index => ({
            index: index,
            step: { ...this.ctvList[index] }
          }))
        };
        this.undoHistory.push(undoData);

        // Mark steps as deleted or remove them
        let deletedCount = 0;
        selectedIndices.reverse().forEach(index => {
          if (this.ctvList[index]._id) {
            // Has ID - mark as deleted
            this.ctvList[index].deleted = 1;
            this.deleteevent.emit(this.ctvList[index]);
          } else {
            // No ID - remove from list
            this.ctvList.splice(index, 1);
          }
          deletedCount++;
        });

        // Show notification
        this.notifys.notify('success', 'Deleted', `${deletedCount} step(s) deleted`);
        
        // Validate after delete
        this.validateService.validateCTV(this.ctvList, false);
        
        this.cdr.detectChanges();
      } else {
        this.notifys.notify('warning', 'Aborted', "Deletion aborted by user");
      }
    });

    this.closeContextMenu();
  }

  getProjectId(): string {
    return localStorage.getItem('projectId') || '';
  }

  toggleImageSnippet(ctv: any, event: MouseEvent): void {
  event.stopPropagation();

  if (!ctv.target.base64_info.image) {
    console.warn('No image snippet found');
    return;
  }

  this.expandedSnippetCtv =
    this.expandedSnippetCtv === ctv ? null : ctv;
}


openSnippet(ctv: any, event: MouseEvent) {
  event.stopPropagation();

  if (!ctv.target.base64_info.originalPath) {
    ctv.target.base64_info.originalPath = ctv.target.base64_info.image;
  }

  const imageKey = ctv.target.base64_info.originalPath.replace(/\.png$/i, '');

  this.restService.get('getBase64Img', imageKey).subscribe({
    next: (presignedUrl: string) => {
      ctv.target.base64_info.image = presignedUrl.trim();
      this.expandedSnippetCtv = ctv;
    },
    error: (err) => {
      console.error('Failed to fetch image URL', err);
    }
  });
}

closeSnippet(event: MouseEvent) {
  event.stopPropagation();

  if (this.expandedSnippetCtv.target.base64_info.originalPath) {
    this.expandedSnippetCtv.target.base64_info.image = 
      this.expandedSnippetCtv.target.base64_info.originalPath;
  }

  this.expandedSnippetCtv = null;
}

toggleEnglishDescriptionView(): void {
  this.showEnglishDescription = !this.showEnglishDescription;
}

getEnglishDescription(ctv: CTVModel): string {
  const saved = (ctv as any).englishDescription || (ctv as any).english_description;
  if (saved) {
    return saved;
  }
  return this.buildEnglishDescription(ctv);
}

private buildEnglishDescription(ctv: CTVModel): string {
  const commandName = ctv.command ? ctv.command.name : '';
  const template = ((ctv.command as any).actionVerb)
    || ((ctv.command as any).action_verb)
    || this.capitalizeFirst(commandName);

  // Old commands you haven't run the $merge on yet still have a plain
  // verb with no {placeholders} — fall back to the old behavior for those.
  if (!template.includes('{')) {
    return this.buildLegacyDescription(ctv, template);
  }

  const targetDesc = this.getTargetPhrase(ctv.target) || '(target)';
  const target2Desc = this.getTargetPhrase((ctv as any).target2) || '(target2)';
  const value1 = this.isValue1Secure(ctv)
    ? 'a secured value'
    : (ctv.value || '(value1)');
  const value2 = this.isValue2Secure(ctv)
    ? 'a secured value'
    : ((ctv as any).value2 || '(value2)');

  const sentence = template
    .replace(/\{target2\}/g, target2Desc)
    .replace(/\{target\}/g, targetDesc)
    .replace(/\{value1\}/g, value1)
    .replace(/\{value2\}/g, value2)
    .trim();

  return sentence.endsWith('.') ? sentence : sentence + '.';
}

// Old behavior, kept as a fallback for any command not yet migrated to a template.
private buildLegacyDescription(ctv: CTVModel, verb: string): string {
  const targetDesc = this.getTargetPhrase(ctv.target);
  const target2Desc = this.getTargetPhrase((ctv as any).target2);

  let sentence = verb;
  if (targetDesc) {
    sentence += ' ' + targetDesc;
  }
  if (target2Desc) {
    sentence += ' and ' + target2Desc;
  }

  const acceptsValue = ctv.command && ctv.command.accepts && ctv.command.accepts.includes('value');
  if (acceptsValue && ctv.value && !this.isValue1Secure(ctv)) {
    sentence += ' with "' + ctv.value + '"';
  }

  return sentence.trim() + '.';
}

private getTargetPhrase(target: any): string {
  if (!target) {
    return '';
  }
  const raw = target.element_description || target.elementDescription || target.desc;
  if (raw && /^(The|An)\s/.test(raw.trim())) {
    const phrase = raw.trim()
      .replace(/\.$/, '')
      .replace(/^(The|An)\s+/, '');
    return 'the ' + phrase;
  }
  // No element_description captured for this target — fall back to its
  // plain recorded name so the sentence is never blank.
  return target.name ? '"' + target.name + '"' : '';
}

private capitalizeFirst(s: string): string {
  if (!s) {
    return '';
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

private populateEnglishDescriptions(): void {
  this.ctvList.forEach(ctv => {
    if (!(ctv as any).manualEnglishDescription) {
      const desc = this.getEnglishDescription(ctv);
      (ctv as any).englishDescription = desc;
      (ctv as any).english_description = desc;
    }
    // else: leave the user's manually-typed description untouched
  });
}


// Inline English-description editing
startDescriptionEdit(index: number) {
  const ctv: any = this.ctvList[index];
  // Seed the field with whatever's currently shown so editing starts from real text, not a stale cache
  ctv.englishDescription = this.getEnglishDescription(ctv);
  ctv._descriptionBackup = ctv.englishDescription;
  ctv.editingDescription = true;
  this.cdr.detectChanges();
}

finishDescriptionEdit(index: number) {
  const ctv: any = this.ctvList[index];
  const edited = (ctv.englishDescription || '').trim();

  this.undoHistory.push({
    type: 'descriptionEdit',
    index: index,
    oldValue: ctv._descriptionBackup,
    oldManualFlag: !!ctv.manualEnglishDescription
  });

  ctv.englishDescription = edited;
  ctv.english_description = edited;
  // Mark it as manually authored so the auto-generator won't clobber it on save
  ctv.manualEnglishDescription = true;

  delete ctv._descriptionBackup;
  ctv.editingDescription = false;
  this.cdr.detectChanges();
}

cancelDescriptionEdit(index: number) {
  const ctv: any = this.ctvList[index];
  if (ctv._descriptionBackup !== undefined) {
    ctv.englishDescription = ctv._descriptionBackup;
    delete ctv._descriptionBackup;
  }
  ctv.editingDescription = false;
  this.cdr.detectChanges();
}


}